<script setup>
import BrandIcon from '../BrandIcon.vue';
</script>

<template>
    <div class="flex gap-3" role="status" aria-live="polite">
        <BrandIcon :size="25" :stroke-width="2.25" />
        <div class="rounded-2xl rounded-tl-md bg-[var(--card)] px-4 py-3">
            <div class="flex items-center gap-1">
                <span class="aia-dot" />
                <span class="aia-dot" style="animation-delay: 150ms" />
                <span class="aia-dot" style="animation-delay: 300ms" />
            </div>
        </div>
    </div>
</template>

<style scoped>
.aia-dot {
    width: 6px;
    height: 6px;
    border-radius: 9999px;
    background: var(--muted-foreground);
    animation: aia-bounce 1.2s ease-in-out infinite;
}
@keyframes aia-bounce {
    0%, 80%, 100% { transform: translateY(0); opacity: 0.5; }
    40% { transform: translateY(-3px); opacity: 1; }
}
@media (prefers-reduced-motion: reduce) {
    .aia-dot { animation: none; opacity: 0.8; }
}
</style>
